import React, { Component } from "react"
import Slider from "react-slick"
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import { throttle, isMobile, equalHeight } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { postApiDatas } from "../../utilities/FrontFunctions/AoxFrontFunctions"
import { trackGA4Event } from '../../utilities/FrontFunctions/AoxTrackingFunctions'

import ObjPushCardFormation from './ObjPushCardFormation'
import { badges } from '../../data/badges';
import ExpertiseBadgeModal from "./Modal/ExpertiseBadgeModal"
import ObjCanvasBadgeExpertise from "./ObjCanvasBadgeExpertise"

import '../../assets/css/0020_objects/0620_obj_swiper_slider.css'
import '../../assets/css/0020_objects/0980_obj_carousel_slick.css'
import '../../assets/css/0020_objects/0700_obj_tabs_parcours_formation.css'
import '../../assets/css/0020_objects/0710_obj_carousel_formation.css'
import '../../assets/css/0020_objects/0960_obj_item_mini_badge.css'
import '../../assets/css/0020_objects/0970_obj_parcours_gagnant.css'

class ObjParcours extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: isMobile(),
            datasParcours: this.props.datasParcours
        }
        this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
        this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
        this.showParcoursFormationBadgeModal = this.showParcoursFormationBadgeModal.bind(this)

		this.handleButtonFav = this.handleButtonFav.bind(this)
    }
    
    handleWindowResizeMainHeader() {
        this.setState({
            isMobile: isMobile()
        })
        this.applyEqualHeight()
    }

    componentDidMount() {
        this.applyEqualHeight()
        window.addEventListener('resize', this.throttleWindowResizeMainHeader)
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.throttleWindowResizeMainHeader)
    }
    applyEqualHeight() {
        setTimeout(() => {
            equalHeight(".obj_tabs_parcours_formation .obj_tabs_content .obj_push_card .ctn_text_card");
        });
    }
    
    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

    showParcoursFormationBadgeModal(){
        this.ParcoursFormationBadgeModal.openModal()
    }

    
    //version pour les tabs de parcours
    handleButtonFav(id) {
        //recherche d'un training correspondant
        var datasTraining = undefined;
        this.state.datasParcours.forEach((datasParcour) => {
            var datasFind = datasParcour.Formations.find(t => t.Training_ItemTraining_Id === id);
            if(datasFind){
                datasTraining = datasFind;
            }
        });
        if(datasTraining){
            if(!datasTraining.Training_IsFavorite){
                //ajouter favori
                document.body.classList.add('is-loading')
                trackGA4Event(window.trackDatas, "training_add_favorite", "training", "training add favorite", "star icon");
                postApiDatas(`/apiaox/Call/AddTrainingFavorite?sIdTraining=${id}`, {})
                .then((res) => {
                    document.body.classList.remove('is-loading')
                    if (!res.IsValid) { alert(res.Message) }
                    else {
                        //switcher le statut sur les listes parcours
                        let newDatas = this.state.datasParcours;
                        newDatas.forEach((datasParcour) => {
                            datasParcour.Formations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = true}});
                        });
                        this.setState({ datasTrainings: newDatas })
                        
                        if(!localStorage.getItem('dontShowAgainModalMAJFormationsFav')){
                            this.ModalFormationsFav.openModal();
                        }
                    }
                });
            } else {
                //supprimer favori
                document.body.classList.add('is-loading')
                postApiDatas(`/apiaox/Call/RemoveTrainingFavorite?sIdTraining=${id}`, {})
                .then((res) => {
                    document.body.classList.remove('is-loading')
                    if (!res.IsValid) { alert(res.Message) }
                    else {
                        //switcher le statut sur les listes parcours
                        let newDatas = this.state.datasParcours;
                        newDatas.forEach((datasParcour) => {
                            datasParcour.Formations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});
                        });
                        this.setState({ datasTrainings: newDatas })
                    }
                });
            }
        }
    }

    render() {
        const { datasParcours, scFields } = this.props

        const IsWinning = datasParcours?.Badge?.BadgeCategory_Code === 'BADGECATEGORY_CADEAU' || datasParcours?.Badge?.BadgeCategory_Code === 'BADGECATEGORY_CADEAU_PRIVILEGE'
        const display = scFields && scFields["Css Class"].value.split(" ").includes("var_formation_interne") ? "parcours-interne" : "parcours-gagnant"
        const NbPieces = (IsWinning && datasParcours.Formations) ? datasParcours.Formations.length : 0
        const NbPiecesCollectées = (NbPieces >0) ? datasParcours.Formations.filter(formation => formation.UserTraining && formation.UserTraining.UserTraining_Score === 100).length : 0;

        const sliderRef = slider => {this.slider = slider}
        const settings = {
            dots: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            // centerMode: true,
            // centerPadding: "0 0 0 170px",
            className: "obj_carousel_slick",
            speed: 750,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        className: "obj_carousel_slick carousel_slick-mobile",
                        centerPadding: "10%",
                        infinite: false,
                        slidesToShow: 1,
                        arrows: false,
                    }
                }
            ]
        }

        return (<>{datasParcours && <>
            <div className={`obj_parcours_gagnant_formation ${scFields ? scFields["Css Class"].value : ''}`}>
                <div className="ctn_parcours_gagnant_formation">

                    <div className="ctn_header">
                        <div className="obj_text">
                            <div className="ctn_text">
                                <h1 className="t_title"><div dangerouslySetInnerHTML={{ __html: datasParcours.Parcours_Title, }}/></h1>
                                <p className="t_subtitle">{datasParcours.Parcours_Subtitle}</p>
                            </div>
                        </div>
                    </div>

                    <div className="ctn_aside">
                        <div className="obj_coin_collect">
                            {IsWinning && 
                                <div className="ctn_coin_collect">
                                    <div className="ctn_text">
                                        <p className="t_desc">{NbPiecesCollectées>1 ? `${NbPiecesCollectées} pièces collectées` : `${NbPiecesCollectées} pièce collectée`}</p>
                                    </div>
                                    <ul className="list_items">
                                        {Array.from({ length: NbPieces }, (_, index) => (
                                            <li key={index} className={`item ${index < NbPiecesCollectées ? 'is_complete' : ''}`}></li>
                                        ))}
                                    </ul>
                                </div>
                            }

                            <div className="ctn_aside_parcours_collect">
                                {datasParcours.Badge && (<>
                                    {/* affichage spé du badge avec l'image animé si acquis */}
                                    {!datasParcours.userBadge ? 
                                        <button onClick={this.showParcoursFormationBadgeModal}>
                                            <picture className="ctn_image">
                                                <img src={(badges.find((item) => item.type === datasParcours.Badge?.Badge_Type)?.theme.find((item) => item.theme === datasParcours.Badge.Badge_Theme))?.imageDisabled_2} alt={datasParcours.Badge.Badge_Title}/>
                                            </picture>
                                        </button>
                                    :
                                        <button className="obj_btn_mini_badge" onClick={this.showParcoursFormationBadgeModal}>
                                            <ObjCanvasBadgeExpertise
                                                badgeItem={datasParcours.Badge}
                                                newBadge = {false}
                                                canvasId={"canvas-parcours-gagnant" + datasParcours.Badge.Badge_Id}
                                                canvasClass = "canvas-parcours-gagnant"
                                            />
                                        </button>
                                    }
                                    <ExpertiseBadgeModal
                                        onRef={ref => (this["ParcoursFormationBadgeModal"] = ref)}
                                        badge={datasParcours.Badge}
                                        userBadge={datasParcours.UserBadge}
                                        badgeDataTheme={badges.find((item) => item.type === datasParcours.Badge?.Badge_Type)?.theme.find((item) => item.theme === datasParcours.Badge.Badge_Theme)}
                                        bodyOpenClassName="ReactModal__Body--open_blur"
                                    />
                                </>)}
                            </div>
                        </div>
                    </div>

                    <div className="ctn_scroll">
                        <Slider {...settings} ref={sliderRef}>
                            {datasParcours.Formations.map((datasTraining, index) => (
                                <div className="item" key={index} >
                                    <ObjPushCardFormation typeofPush="Formation" display={display} datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
                                </div>
                            ))}

                        </Slider>

                        <div className="ctn_aside_scroll">
                            <div className="obj_text">
                                <div className="ctn_text">
                                    <div dangerouslySetInnerHTML={{ __html: datasParcours.Parcours_Text, }}/>                                    
                                </div>
                            </div>
                        </div>
                    </div>

                    {IsWinning && 
                        <div className="ctn_text-legal">
                            <p className="t_legal">*Seuls les points de vente distributeurs de la marque sont éligibles.</p> 
                        </div>
                    }

                    {scFields && scFields["Image Background"]?.value.src && 
                        <div className='ctn_background'>
                            <div className='obj_image image_cover'>
                                <picture className='ctn_image fade-in'>
                                    <source srcSet={scFields["Image Background Mobile"]?.value.src} media="(max-width:767px)"/>
                                    <img src={scFields["Image Background"]?.value.src} alt={""}/>
                                </picture>
                            </div>
                        </div>
                    }

                </div>
            </div>
        </>}</>)
    }
}

export default withTranslation()(withSitecoreContext()(ObjParcours));